import { DeleteIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import type { WithDataTestid } from '@vlabs/uikit/types';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import type { DeletePermissionTagsProps } from '../types';
import { useDeletePermissionTags } from './useDeletePermissionTags';

type DeletePermissionTagsIconButtonProps = DeletePermissionTagsProps & WithDataTestid & IconButtonProps;

const displayName = 'DeletePermissionTagsIconButton';
const testid = buildTestid(displayName);

function DeletePermissionTagsIconButton({
  permissionTags: permissionTagsIds,
  'data-testid': dataTestId = undefined,
  ...props
}: DeletePermissionTagsIconButtonProps): JSX.Element {
  const deletePermissionTag = useDeletePermissionTags({ permissionTags: permissionTagsIds });
  return (
    <IconButton
      icon={<DeleteIcon />}
      kind="negative"
      onClick={deletePermissionTag}
      variant="flat"
      {...testid(dataTestId)}
      {...props}
    />
  );
}

DeletePermissionTagsIconButton.displayName = displayName;

export { DeletePermissionTagsIconButton };
